"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { NavArrowLeft, NavArrowRight } from "iconoir-react";
import { useEffect, useState, } from "react";
import { Stack } from "./Stack.js";
import { useCarouselController, } from "./useCarousel.js";
export function Carousel({ children, config, labels = { previous: "Forrige", next: "Neste" }, as: ListType, controls, id, ...rest }) {
    const { ref, onNext, onPrevious, nextEnabled, previousEnabled, aria } = useCarouselController({ id, ...config });
    const [hasOverflow, setHasOverflow] = useState(false);
    useEffect(() => {
        const list = ref.current;
        if (!list)
            return;
        const updateOverflow = () => {
            setHasOverflow(list.scrollWidth > list.clientWidth);
        };
        const observer = new ResizeObserver(updateOverflow);
        observer.observe(list);
        for (const item of list.children)
            observer.observe(item);
        updateOverflow();
        return () => observer.disconnect();
    }, [ref, children]);
    return (_jsxs(_Fragment, { children: [!controls?.hide && hasOverflow ? (_jsxs("div", { className: classNames("cvr-stack-carousel--controls", controls?.className), children: [_jsxs("button", { className: classNames("absolute -left-12 flex h-8 w-8 cursor-pointer items-center justify-center transition-transform duration-200 ease-in-out hover:scale-105", {
                            "opacity-30": !previousEnabled,
                        }), disabled: !previousEnabled, onClick: onPrevious, ...aria.previous, children: [_jsx(NavArrowLeft, { width: 32, height: 32 }), _jsx("span", { className: "sr-only", children: labels.previous })] }), _jsxs("button", { className: classNames("absolute -right-12 flex h-8 w-8 cursor-pointer items-center justify-center transition-transform duration-200 ease-in-out hover:scale-105", {
                            "opacity-30": !nextEnabled,
                        }), disabled: !nextEnabled, onClick: onNext, ...aria.next, children: [_jsx(NavArrowRight, { width: 32, height: 32 }), _jsx("span", { className: "sr-only", children: labels.next })] })] })) : null, _jsx(Stack, { as: ListType, ...aria.reel, ...rest, ref: ref, variant: "carousel", children: children })] }));
}
